import { Navigate } from 'react-router';
import { usePermissions } from '@/hooks/usePermissions';
import { useAuthStore } from '@/stores/auth-store';
import { ROLE_TYPES } from '@scio3/shared-types';

/**
 * Route guard that redirects restricted roles (READ_ONLY, CONTENT_PROPOSAL, CONTENT_APPROVAL, and the
 * Group Security v3 BILLING role) to the Screens page. Wraps individual content route elements
 * (templateManagement, playbackReport, ai-analytics) — NOT an Outlet layout route.
 *
 * Group Security v3 (D4): the Billing role reaches Billing & Orders (those routes are NOT wrapped by
 * RestrictedRoute, so they stay reachable) but content is read-only — so Billing is treated as restricted
 * here, blocking the content-authoring routes this guard protects.
 */
export function RestrictedRoute({ children }: { children: React.ReactNode }) {
  const me = useAuthStore((s) => s.me);
  const { teamRole } = usePermissions();

  // While user data is loading, don't flash redirect — show nothing (ProtectedRoute handles auth loading)
  if (!me) return null;

  const isRestricted =
    teamRole === ROLE_TYPES.READ_ONLY ||
    teamRole === ROLE_TYPES.CONTENT_PROPOSAL ||
    teamRole === ROLE_TYPES.CONTENT_APPROVAL ||
    teamRole === ROLE_TYPES.BILLING;

  if (isRestricted) {
    return <Navigate to="/app/screenManagement" replace />;
  }

  return <>{children}</>;
}
